/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type Page from '@jira/project-settings__board-settings-roadmap-entry/src/RoadmapPageLoader.tsx';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import getMeta from '@jira/platform__utils-get-meta/src/utils/get-meta/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyRoadmap: LazyComponent<() => React.JSX.Element> = lazyForPaint<typeof Page>(
	() =>
		import(
			/* webpackChunkName: "async-board-settings-roadmap", jiraSpaEntry: "async-board-settings-roadmap" */ '@jira/project-settings__board-settings-roadmap-entry/src/RoadmapPageLoader.tsx'
		),
);

const AsyncProjectSettingsRoadmap = (): React.JSX.Element => (
	<JSErrorBoundary
		id="project-settings.roadmap"
		teamName="chronos"
		attributes={{
			isSynthetic: fg('is_synthetic_tenant') || getMeta('ajs-is-synthetic') === 'true',
		}}
	>
		<LazyPage Page={LazyRoadmap} pageId="board-settings-roadmap" shouldShowSpinner={false} />
	</JSErrorBoundary>
);

export default AsyncProjectSettingsRoadmap;
